export default {
  regular: {
    en: 'Regular price',
  },
  memberPrice: {
    en: 'Member price',
  },
}
